(function(){
    'use strict';

    angular
        .module('completeAir')
        .controller('branchOfficesController', branchOfficesController)
        .controller('newBranchOfficeController', newBranchOfficeController)
        .controller('editBranchOfficeController', editBranchOfficeController)
        .controller('deleteBranchOfficeController', deleteBranchOfficeController);

    branchOfficesController.$inject = ['branchOffices', 'linkService'];
    newBranchOfficeController.$inject = ['countries', 'linkService', 'regionService', 'cityService',
        'branchOfficeService', 'airportService'];
    editBranchOfficeController.$inject = ['branchOfficeId', 'branchOffice', 'countries', 'linkService', 'regionService',
        'cityService', 'branchOfficeService', 'airportService'];
    deleteBranchOfficeController.$inject = ['branchOfficeId', 'branchOffice', 'branchOfficeService', '$uibModalInstance'];

    function branchOfficesController(branchOffices, linkService){
        var vm = this;
        vm.linkService = linkService;
        vm.branchOffices = (branchOffices.data._embedded)? branchOffices.data._embedded.branchOffices : [];
        vm.pages = branchOffices.data.page;
    }

    function newBranchOfficeController(countries, linkService, regionService, cityService, branchOfficeService, airportService){
        var vm = this;
        vm.countries = countries;
        vm.regions = [];
        vm.cities = [];
        vm.disableSelects = false;
        vm.selectCheckBox = {};
        vm.branchOffice = {
            isInAirport: false,
            paymentByPos: false,
            establishment: 0,
            phones: [
                {
                    prefix : undefined,
                    number : undefined
                }
            ]
        };
        vm.requiredCheck = true;
        vm.cont = 0;
        vm.buttonSave = false;

        vm.getRegions = function(country){
            getRegions(country, regionService, linkService, vm);
        }

        vm.getCities = function(region){
            vm.cities = getCities(region, cityService, linkService, vm);
        }

        vm.getAirports = function(region, city){
            vm.airports = getAirports(region, city, linkService, airportService, vm);
        }

        vm.saveBranchOffice = function(isValid, branchOffice){
            if(isValid){
                branchOffice.cargoOffice = (vm.selectCheckBox[1]) ? true : false;
                branchOffice.ticketOffice = (vm.selectCheckBox[2]) ? true : false;
                branchOffice.regionId = parseInt(linkService.getLinkId(branchOffice.region._links.self.href));
                branchOffice.cityId = parseInt(linkService.getLinkId(branchOffice.city._links.self.href));
                branchOffice.airportId = branchOffice.isInAirport ?
                    parseInt(linkService.getLinkId(branchOffice.airport._links.self.href)):undefined;
                branchOffice.phone = getPhone(branchOffice.phones);
                branchOffice.establishment = branchOffice.paymentByPos?branchOffice.establishment:0;
                branchOfficeService.saveBranchOffice(branchOffice);
            }
        }

        vm.change = function(){
            vm.requiredCheck = !(vm.selectCheckBox[1] || vm.selectCheckBox[2]);
            vm.cont++;
        }

        vm.addPhones = function(){
            vm.branchOffice.phones.push({
                'prefix': undefined,
                'number': undefined
            });
        }

        vm.deletePhones = function(index){
            vm.branchOffice.phones.splice(index, 1)
        }
    }

    function editBranchOfficeController(branchOfficeId, branchOffice, countries, linkService, regionService, cityService,
                                        branchOfficeService,airportService){
        var vm = this;
        vm.disableSelects = true;
        vm.branchOffice = branchOffice.data;
        vm.countries = countries;
        vm.regions = [];
        vm.cities = [];
        vm.selectCheckBox = {
            1: branchOffice.data.cargoOffice,
            2: branchOffice.data.ticketOffice
        };
        getRegions(branchOffice.data._embeddeds.city._embedded.country, regionService, linkService, vm);
        getCities(branchOffice.data._embeddeds.city._embedded.region, cityService, linkService, vm);
        vm.branchOffice.city = branchOffice.data._embeddeds.city;
        vm.branchOffice.region = branchOffice.data._embeddeds.city._embedded.region;
        vm.branchOffice.country = branchOffice.data._embeddeds.city._embedded.country;
        vm.branchOffice.airport = branchOffice.data._embeddeds.airport;
        vm.branchOffice.isInAirport = branchOffice.data.airportId==null?false:true;
        vm.branchOffice.paymentByPos = branchOffice.data.paymentByPos==0?false:true;
        vm.branchOffice.phones = setPhones(vm.branchOffice.phone);

        vm.old = angular.copy(vm.branchOffice);
        vm.oldBox = angular.copy(vm.selectCheckBox);
        vm.buttonSave = true;
        vm.requiredCheck = false;
        vm.cont = 1;

        vm.getAirports = function(region, city){
            vm.airports = getAirports(region, city, linkService, airportService, vm);
        }
        vm.getAirports(vm.branchOffice.region, vm.branchOffice.city);

        vm.saveBranchOffice = function(isValid, branchOffice){
            if (isValid) {
                branchOffice.cargoOffice = (vm.selectCheckBox[1]) ? true : false;
                branchOffice.ticketOffice = (vm.selectCheckBox[2]) ? true : false;
                branchOffice.airportId = branchOffice.isInAirport ?
                    parseInt(linkService.getLinkId(branchOffice.airport._links.self.href)):undefined;
                branchOffice.phone = getPhone(branchOffice.phones);
                branchOffice.establishment = branchOffice.paymentByPos?branchOffice.establishment:0;
                branchOfficeService.updateBranchOffice(branchOffice, branchOfficeId);
            }
        }

        vm.change = function(){
            if(vm.branchOffice.country != undefined && vm.branchOffice.country.name == vm.old.country.name &&
                vm.branchOffice.region != undefined && vm.branchOffice.region.name == vm.old.region.name &&
                vm.branchOffice.city != undefined && vm.branchOffice.city.name == vm.old.city.name &&
                vm.branchOffice.name.toUpperCase() == vm.old.name.toUpperCase() &&
                vm.branchOffice.address.toUpperCase() == vm.old.address.toUpperCase() &&
                getPhone(vm.branchOffice.phones) == vm.old.phone&&
                vm.selectCheckBox[1] == vm.oldBox[1] && vm.selectCheckBox[2] == vm.oldBox[2] &&
                vm.branchOffice.isInAirport == vm.old.isInAirport && vm.branchOffice.paymentByPos == vm.old.paymentByPos){
                if(vm.branchOffice.isInAirport){
                    if(vm.branchOffice.airport != undefined && vm.branchOffice.airport.name == vm.old.airport.name){
                        vm.buttonSave = true;
                    }else{
                        vm.buttonSave = false;
                    }
                }else{
                    vm.buttonSave = true;
                }

                if(vm.branchOffice.paymentByPos){
                    if(vm.branchOffice.establishment == vm.old.establishment){
                        vm.buttonSave = true;
                    }else{
                        vm.buttonSave = false;
                    }
                }else{
                    vm.buttonSave = true;
                }
            }else{
                vm.buttonSave = false;
            }

            vm.requiredCheck = !(vm.selectCheckBox[1] || vm.selectCheckBox[2]);
        }

        vm.addPhones = function(){
            vm.branchOffice.phones.push({
                'prefix': undefined,
                'number': undefined
            });
        }

        vm.deletePhones = function(index){
            vm.branchOffice.phones.splice(index, 1)
        }
    }

    function deleteBranchOfficeController(branchOfficeId, branchOffice, branchOfficeService, $uibModalInstance){
        var vm = this;
        vm.name = branchOffice.data.name;

        vm.deleteBranchOffice = function(){
            branchOfficeService.deleteBranchOffice(branchOfficeId)
                .then(function(){
                    $uibModalInstance.close(true);
                })
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

    function getRegions(country, regionService, linkService, vm){
        if(country != undefined){
            regionService.getRegionsByCountry(linkService.getLinkId(country._links.self.href))
                .then(function(response){
                    vm.regions = response;
                });
        }else{
            vm.regions = [];
        }
    }

    function getCities(region, cityService, linkService, vm){
        if(region != undefined){
            cityService.getCitiesByRegion(linkService.getLinkId(region._links.self.href), true, true)
                .then(function(res){
                    vm.cities = res;
                });
        }else{
            vm.cities = [];
        }
    }

    function getAirports(region, city, linkService, airportService, vm){
        if(region != undefined && city != undefined){
            airportService.getAirportsByRegionAndCity(parseInt(linkService.getLinkId(region._links.self.href)),
                parseInt(linkService.getLinkId(city._links.self.href)))
                .then(function(res){
                    vm.airports = res;
                });
        }else{
            vm.airports = [];
        }
    }

    function getPhone(phones){
        var res = '';
        angular.forEach(phones, function(phone){
                res = res+(res.length==0?'':',')+phone.prefix+'-'+phone.number
            });
        return res;
    }

    function setPhones(phone){
        var res = [];
        angular.forEach(phone.split(','), function(splitPhone){
            res.push({
                'prefix': splitPhone.split('-')[0],
                'number': splitPhone.split('-')[1]
            });
        });
        return res;
    }
})();
